export default __webpack_public_path__ + "static/index-illustration-bbdf868914cbd8f58cd8679b07849782.svg";